import { render } from "./CardKeywordList.vue?vue&type=template&id=22d2b3b3&scoped=true&ts=true"
import script from "./CardKeywordList.vue?vue&type=script&lang=ts"
export * from "./CardKeywordList.vue?vue&type=script&lang=ts"

import "./CardKeywordList.vue?vue&type=style&index=0&id=22d2b3b3&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d2b3b3"]])

export default __exports__